import { connect } from 'react-redux';
import View from './FinancialPlanWarningView';
import { hide } from './FinancialPlanWarningActions';
import {
  warningMessage,
  warningType,
  hasWarningMessage,
  key as keySelector,
  hidden,
} from './FinancialPlanWarningSelector';

const mapStateToProps = (state, ownProps) => ({
  hidden: hidden(state, ownProps),
  keyr: keySelector(state, ownProps),
  warningType: warningType(state, ownProps),
  warningMessage: warningMessage(state, ownProps),
  hasWarningMessage: hasWarningMessage(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  hide: (key, clientId) => () => dispatch(hide(key, clientId)),
  goToCashflow: clientId => () => {
    window.ADV.util.Router.go2('ProjectedCashFlowReport', {
      clientId,
      mode: 0,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
